import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
	FreudCardModule,
	FreudInputTextModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import {
	HighlightPipe,
	VCHistoryCardComponent,
} from './vc-history-card.component';

@NgModule({
	declarations: [VCHistoryCardComponent, HighlightPipe],
	imports: [
		CommonModule,
		FreudInputTextModule,
		TranslateModule,
		FreudCardModule,
	],
	exports: [VCHistoryCardComponent],
	providers: [],
})
export class VCHistoryCardModule {}
